import { API_FILE_TYPE, FILE_CATEGORY } from './constants';

export {
  getBytesFromMb,
  getMbFromBytes,
  getFileExtension,
  getFileTypeFromName,
  mapToFileData,
  isLinkExpired,
} from 'framework/files';

export const getFileType = (file: Blob): string => {
  const fileCategories = Object.values(FILE_CATEGORY) as Array<{ icon: string; mimeTypes: string[] }>;
  const isImage = (FILE_CATEGORY.IMG.mimeTypes as string[]).includes(file.type);
  const isKnownType = fileCategories.some(category => category.mimeTypes.includes(file.type));

  let fileType = 'image';

  if (!isImage) {
    if (isKnownType) {
      fileCategories.forEach(category => {
        if (category.mimeTypes.includes(file.type)) {
          Object.values(API_FILE_TYPE).forEach(type => {
            if (type.category === category) {
              fileType = type.alias;
            }
          });
        }
      });
    } else {
      fileType = 'doc';
    }
  }

  return fileType;
};

export const getFilePreview = (file: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileCategories = Object.values(FILE_CATEGORY) as Array<{ icon: string; mimeTypes: string[] }>;
    const isImage = (FILE_CATEGORY.IMG.mimeTypes as string[]).includes(file.type);
    const isKnownType = fileCategories.some(category => category.mimeTypes.includes(file.type));
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = event =>
      resolve(
        (() => {
          let filePreview = typeof event.target?.result === 'string' ? event.target.result : '';

          if (!isImage) {
            if (isKnownType) {
              fileCategories.forEach(category => {
                if (category.mimeTypes.includes(file.type)) {
                  filePreview = category.icon;
                }
              });
            } else {
              filePreview = FILE_CATEGORY.DOC.icon;
            }
          }
          return filePreview;
        })(),
      );
    reader.onerror = error => reject(error);
  });
};

export const getFileTypeIcon = (type: string) => {
  const artifactType = type.toLowerCase() as keyof typeof API_FILE_TYPE;

  return artifactType in API_FILE_TYPE
    ? API_FILE_TYPE[artifactType].category.icon
    : API_FILE_TYPE.default.category.icon;
};
